module.exports = __webpack_public_path__ + "img/LogoProsa_Gris.afade10d.png";